import { sensorTotalConsumptionConstants } from "../../constants/client";

const initialState = {};

export default function sensorTotalConsumption(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_REQUEST:
      currentstate = {
        data: null,
        loading: true
      };
      break;
    case sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_SUCCESS:
      currentstate = {
        data: action.payload.data,
        loading: false
      };
      break;
    case sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_FAILURE:
      currentstate = { error: action.payload, loading: false };
      break;

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
